import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormFieldComponent } from '@core/components/form-field/form-field.component';
import { AffiliatesService } from '@features/affiliates/services/affiliates.service';
import { BalanceIconComponent } from '@core/components/balance-icon/balance-icon.component';
import { ToastrService } from 'ngx-toastr';
import { ModalService } from '@features/modals/services/modal.service';

@Component({
  selector: 'app-affiliates-code-modal',
  imports: [FormFieldComponent, ReactiveFormsModule, BalanceIconComponent],
  templateUrl: './affiliates-code-modal.component.html',
  styleUrl: './affiliates-code-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class AffiliatesCodeModalComponent {
  private readonly affiliatesService = inject(AffiliatesService);
  private readonly toastrService = inject(ToastrService);
  private readonly modalService = inject(ModalService);

  public affiliateCode = new FormControl<string>('', [Validators.required]);
  public isLoading = signal<boolean>(false);

  public async redeemAffiliateCode() {
    const code = this.affiliateCode.value?.trim();

    if (!code) {
      return;
    }

    this.isLoading.set(true);

    try {
      const message = await this.affiliatesService.redeemReferralCode(code);

      if (message) {
        this.toastrService.success(message);
        this.modalService.close();
      }
    } catch (error: any) {
      console.log('🚀 ~ AffiliatesComponent ~ claimAffiliates ~ error:', error);
      this.affiliateCode.setErrors({ api: error });
    } finally {
      this.isLoading.set(false);
    }
  }
}
